<template>
  <div class="container-lg">
    <div v-show="!cargando">
      <div class="flex-center">
        <div class="buscar flex-column">
          <div class="div-row div-date-pickers">
            <!-- Fecha Inicio -->        
            <DatePicker
                    class="date-picker"
                    v-model="filtro.fechaInicio"
                    format="DD/MM/YYYY"
                    value-type="YYYY-MM-DD"
                    placeholder="DD/MM/YYYY"
                    :editable="false">
            </DatePicker>
            <!-- Fecha Fin -->
            <DatePicker
                    class="date-picker"
                    v-model="filtro.fechaFin"
                    format="DD/MM/YYYY"
                    value-type="YYYY-MM-DD"
                    placeholder="DD/MM/YYYY"
                    :editable="false">
            </DatePicker>
          </div>

          <div class="div-row">
            <!-- Descripción -->
            <input
              type="text"
              v-model="filtro.descripcion"
              class="form-control"
              placeholder="Descripción"
              aria-describedby="basic-addon1"
              maxlength="40"
            />
          </div>

          <div class="div-row">
            <!-- Operación -->
            <select v-model="filtro.tipo" class="custom-select">
              <option v-bind:value="null">Ninguna</option>
              <option
                v-for="auditoria in auditoriaTipoEnum"
                v-bind:key="auditoria.id"
                v-bind:value="auditoria.descripcion"
              >
                {{ auditoria.descripcion }}
              </option>
            </select>
          </div>

          <div class="div-row">
            <!-- Buscar -->
            <button type="button" class="btn btn-success btn-accion" @click="clickBuscar()">
              Buscar
              <font-awesome-icon :icon="Icons.BUSCAR" />
            </button>

            <!-- Limpiar -->
            <button type="button" class="btn btn-success btn-accion" @click="clickLimpiar()">
              Limpiar
              <font-awesome-icon :icon="Icons.ATRAS" />
            </button>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <table id="tablaEstadisticas" class="table table-hover">
          <thead>
            <tr>
              <th>Operación</th>
              <th>Entidad</th>
              <th>Descripción</th>
              <th>Ocurrencias</th>
              <th>Fecha Inicial</th>
              <th>Última fecha</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="auditoria in lista" v-bind:key="auditoria.id">
              <td>{{ auditoria.operacionReferencia }}</td>
              <td>{{ auditoria.claseReferencia }}</td>
              <td>{{ auditoria.descripcion }}</td>
              <td>{{ auditoria.visitas }}</td>
              <td>
                <div>{{ frontEndDateFormat(auditoria.fechaAlta) }}</div>
              </td>
              <td>{{ auditoria.fechaModificacion ? frontEndDateFormat(auditoria.fechaModificacion) : "-"}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div v-show="cargando" class="spinner-border" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { Api } from "../../../api";
import { Icons as IconConstants } from "../../../constants";
import { BeneficioAdministradorService} from "../../../servicios/administrador/beneficio.administrador.service";
import { Util } from "../../../util";
import DatePicker from "vue2-datepicker";

const moment = require("moment");

// Usado en el filtro de auditoria
const ITEM_FILTRO = {
  fechaInicio: null,
  fechaFin: null,
  desde: null,
  hasta: null,
  tipo: null,
  descripcion:null,
  busqueda: {
    valor: null,
    buscarPor: null,
    ordenarPor: null,
  },
};

export default {
  components: {
    FontAwesomeIcon, DatePicker
  },
  props: {
    busqueda: Object,
  },
  data() {
    return {
      cantidad: 0,
      filtro: Util.copiaProfunda(ITEM_FILTRO),
      auditoriaTipoEnum: [
        { id: 1, descripcion: "Alta de Suscripción" },
        { id: 2, descripcion: "Búsqueda de Comercio" },
        { id: 3, descripcion: "Búsqueda de Categoría" },
        { id: 4, descripcion: "Búsqueda de Sub-Categoría" },
        { id: 5, descripcion: "Búsqueda de Beneficios en Localidad" },
        { id: 6, descripcion: "Búsqueda de Comercios en Localidad" },
        { id: 7, descripcion: "Calificacion de Comercio" },
        { id: 8, descripcion: "Cliente con suscripciones" },
        { id: 9, descripcion: "Alta de Comercio" },
        { id: 10, descripcion: "Baja de Comercio" },
      ],
      cargando: true,
      lista: [],
      pagina: 1,
      servicio: new BeneficioAdministradorService(),
      token: null,
    };
  },
  computed: {
    Icons() {
      return IconConstants;
    },
  },
  watch: {
    busqueda() {
      this.iniciar();
    },
  },
  methods: {
    // Los métodos con "Evento" adelante son llamados desde afuera, si se cambia su interface, hay que cambiar afuera
    EventoCargar() {
      this.cargar();
    },
    clickBuscar() {
      this.buscar();
    },
    clickLimpiar() {
      this.filtro.tipo = null;
      this.filtro.fechaInicio =null;
      this.filtro.fechaFin =null;
      this.filtro.valor = null;
      this.lista = [];      
    },
    frontEndDateFormat: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    // Cuando se crea un elemento
    EventoCreado(elemento) {
      console.log("elemento creado: " + elemento);
      this.cantidad++;
      this.cargar();
    },
    // Cuando se edita un elemento
    EventoEditado(elemento) {
      console.log("elemento editado: " + elemento);
      this.cargar();
    },
    // Cuando se elimina un elemento
    EventoEliminado(elemento) {
      console.log("elemento eliminado: " + elemento);
      this.cantidad--;
      this.cargar();
    },

    // Metodos privados
    cargar() {
      this.cargando = true;
      Api.Estadistica.findAuditoriaOrderByOperacionAndVisitas(this.token).then(
        (response) => {
          this.lista = response.data;
          this.cargando = false;
        }
      );
    },

    buscar() {
      this.cargando = true;
      const filtroDTO = {
        fechaInicio: this.filtro.fechaInicio,
        fechaFin: this.filtro.fechaFin,
        desde: null,
        hasta: null,
        tipo: this.filtro.tipo,
        busqueda: {
          valor: this.filtro.descripcion,
          buscarPor: 5,
          ordenarPor: null,
        },
      };
      
      Api.Estadistica.findAuditoriaFiltro(filtroDTO, this.token).then(
        (response) => {
          this.lista = response.data;
          this.cargando = false;
        }
      );
    },

    iniciar() {
      this.cargando = false;
      this.pagina = 1;
      this.lista = [];      
    },
    paginaCambiada(numero) {
      this.pagina = numero;
      this.cargar();
      // Scrollear al principio de la tabla
      Util.scrollearAId("tablaEstadisticas", true);
    },
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.iniciar();
  },
};
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex; 
  justify-content: center;
}

.flex-column {
  display: flex;
  flex-direction: column;
}

.div-row {
  margin: 5px 0;
}

.div-date-pickers {
  display: flex; 
  justify-content: space-between;
  column-gap: 5px;
  
  /* Fecha inicio y Fin */
  .date-picker {
    width: 150px;
    text-align: center;
  }
}

.btn-accion {
  margin: 0px 5px 5px;
  width: 100px;
}

@media screen and (max-width: 335px) {
  .div-row {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .div-date-pickers {
      row-gap: 5px !important;
    }

    .date-picker {
        width: 100% !important;
        margin: 5px 0 !important;
    }
  }
}
</style>
